module.exports = __webpack_public_path__ + "static/media/C_E01.4d86bc1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/C_E01.png
// module id = 69
// module chunks = 0